import { DOCUMENT, NgClass } from '@angular/common';
import { Component, computed, effect, Inject, model, Renderer2 } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faRightFromBracket, faHouseChimney, faUser, type IconDefinition, faUserTie } from '@fortawesome/free-solid-svg-icons';
import { UserBadgeComponent } from '../user-badge/user-badge.component';
import { AccessService } from './../../services/access/access.service';
import { UserType } from '../../shared/models/user.model';

@Component({
  selector: 'app-sidebar',
  imports: [
    UserBadgeComponent,
    NgClass,
    RouterLink,
    RouterLinkActive,
    FaIconComponent
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  readonly exitIcon: IconDefinition = faRightFromBracket;
  readonly homeIcon: IconDefinition = faHouseChimney;
  readonly profileIcon: IconDefinition = faUser;
  readonly adminIcon: IconDefinition = faUserTie;

  readonly isActive = model.required<boolean>();
  readonly userFullName = computed(() => {
    const info = this.accessService.userInfo()!;
    return `${info.name} ${info.lastName}`;
  });
  readonly isAdmin = computed(() => {
    const info = this.accessService.userInfo()!;
    return info.type === UserType.ADMIN;
  })

  constructor(private readonly accessService: AccessService,
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    effect(() => {
      if (this.isActive()) {
        this.renderer.addClass(this.document.body, 'overflow-hidden');
      } else {
        this.renderer.removeClass(this.document.body, 'overflow-hidden');
      }
    });
  }

  onLogout(): void {
    this.accessService.logout();
  }

  onToggleSidebar(): void {
    this.isActive.update((prev) => !prev);
  }
}
